import React from 'react';
import { motion } from 'framer-motion';
import { DollarSign, Clock, Award, Flag } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    icon: DollarSign,
    title: 'Low 24-Piece Minimums',
    desc: 'Order as few as 24 pieces. Perfect for small teams, seasonal staff, or test runs.'
  }, {
    icon: Clock,
    title: 'Fast 5-7 Day Turnaround',
    desc: 'Need uniforms fast? We print and ship your business apparel in record time.'
  }, {
    icon: Award,
    title: 'Pro DTF & Screen Print',
    desc: 'Vibrant colors for shirts, polos, and uniforms. Quality that lasts wash after wash.'
  }, {
    icon: Flag,
    title: 'Printed IN HOUSE in San Diego, CA',
    desc: 'Support local business. Every piece of apparel is printed in our USA facility.'
  }];
  return <section className="py-24 bg-white" data-id="element-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-14">
          <h2 className="text-4xl md:text-5xl font-black mb-4" data-id="element-15">
            Why Businesses Choose Us
          </h2>
          <div className="w-24 h-2 bg-black mx-auto" data-id="element-16"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-17">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -10
        }} className="bg-white border-4 border-black p-8 text-center group hover:bg-black hover:text-white transition-colors duration-300" data-id="element-18">
              <div className="w-16 h-16 bg-black text-white rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-white group-hover:text-black transition-colors duration-300" data-id="element-19">
                <benefit.icon className="w-8 h-8" strokeWidth={2.5} data-id="element-20" />
              </div>
              <h3 className="text-xl font-black mb-3 uppercase tracking-wide" data-id="element-21">
                {benefit.title}
              </h3>
              <p className="text-gray-600 group-hover:text-gray-300 font-medium" data-id="element-22">
                {benefit.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}